import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary, UiProvider, installGlobalErrorHandlers } from '@figma-importers/ui'
import App from './App.tsx'
import { redirectIfVisitedDirectly } from './community-redirect'
import { initTelemetry } from './telemetry'

// Someone who typed the domain into a browser wants the Community listing, not
// a plugin panel with no plugin behind it. Runs before anything renders, so a
// visitor never sees a UI they can't use. Inside Figma this is a no-op — see
// community-redirect.ts for how it tells the two apart.
redirectIfVisitedDirectly(window)

// These handlers are installed before the first render, and therefore before
// the sandbox handshake that says which of the two published plugins this
// window belongs to. So boot-time failures are attributed to the codebase; once
// the handshake lands, App.tsx reports under the specific variant's key.
const APP_NAME = 'ai-eps-importer'

// Capture uncaught errors + unhandled rejections before the first render.
installGlobalErrorHandlers({ app: APP_NAME })

// Give those errors somewhere to go. This only registers the sink; nothing is
// sent until the handshake says which plugin we are (see telemetry.ts), so an
// error during boot is logged locally and not attributed to the wrong listing.
initTelemetry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UiProvider>
      <ErrorBoundary app={APP_NAME}>
        <App />
      </ErrorBoundary>
    </UiProvider>
  </StrictMode>,
)
